<template>
    <div class="nps-question">
        <label v-bind:class="{ error: valid === false, valid: valid === true }"
            ><slot name="label"></slot
        ></label>
        <div class="text-recomend">
            <p>Não recomendaria</p>
            <p>Recomendaria</p>
        </div>
        <div class="points clearfix">
            <div
                v-for="i in 7"
                :key="i - 1"
                class="point"
                @click="setValue(i - 1)"
                v-bind:class="{
                    active: currentValue == i - 1,
                    inactive: currentValue !== null && currentValue !== i - 1,
                }"
            >
                {{ i - 1 }}
            </div>
            <div
                v-for="i in 2"
                :key="i + 6"
                class="point"
                @click="setValue(i + 6)"
                v-bind:class="{
                    active: currentValue == i + 6,
                    inactive: currentValue !== null && currentValue !== i + 6,
                }"
            >
                {{ i + 6 }}
            </div>
            <div
                v-for="i in 2"
                :key="i + 8"
                class="point"
                @click="setValue(i + 8)"
                v-bind:class="{
                    active: currentValue == i + 8,
                    inactive: currentValue !== null && currentValue !== i + 8,
                }"
            >
                {{ i + 8 }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "nps-question",
    props: {
        value: {
            type: Number,
            default: null,
        },
    },
    data: function () {
        return {
            currentValue: this.value,
            error: null,
            valid: null,
        };
    },
    methods: {
        setValue: function (value) {
            if (this.currentValue == value) {
                this.currentValue = null;
            } else {
                this.currentValue = value;
            }
            this.$emit("change", this.currentValue);
        },
        getValue: function () {
            return this.currentValue;
        },
        isValid: function () {
            this.valid = null;
            this.error = null;
            if (this.currentValue === null) {
                this.valid = false;
                this.error = "Selecione uma opção.";
                return false;
            }
            this.valid = true;
            return true;
        },
        isNull: function () {
            if (this.currentValue === null) {
                return true;
            }
            return false;
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>
